export default __webpack_public_path__ + "static/media/Zugite Heretic Staff.d30ec2fe.jpg";